<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goToNewTournament = () => {
  router.push({ name: 'tournament-new' })
}
</script>

<template>
  <v-row justify="center" class="mt-8">
    <v-col cols="12" sm="8" md="6" lg="4">
      <v-card 
        elevation="2" 
        hover 
        @click="goToNewTournament"
        class="cursor-pointer"
      >
        <v-card-text class="text-center pa-8">
          <v-icon size="64" color="primary" class="mb-4">
            mdi-trophy
          </v-icon>
          <h2 class="text-h5 mb-4">{{ $t('tournaments.createNew') }}</h2>
          <v-btn
            color="primary"
            size="large"
            elevation="2"
            block
          >
            <v-icon start>mdi-plus</v-icon>
            {{ $t('tournaments.newTournament') }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>